import { render, staticRenderFns } from "./InspectionFormMultipliersList.vue?vue&type=template&id=612d1a34"
import script from "./InspectionFormMultipliersList.vue?vue&type=script&lang=js"
export * from "./InspectionFormMultipliersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports